import * as moment from 'moment';

export class VehicleCashout {
  id: number;
  vehicleId: number;
  amount: number;
  date: string; // dateString

  constructor(){
    this.amount = 0;
    this.date = moment().format('YY-MM-DD');
  }
}



// WEBPACK FOOTER //
// ./src/app/models/vehicles/vehicle-cashout.ts